<template>
  <div class="AssociationIntro">
    <!-- 协会简介 -->
    <div class="cont cont1 wow bounceInUp">
      <Intoduction></Intoduction>
    </div>
    <div class="cont cont2 wow bounceInUp">
      <Presidentunit></Presidentunit>
    </div>
    <div class="cont cont3 wow bounceInUp">
      <ServiceArea></ServiceArea>
    </div>
    <div class="cont cont3 wow bounceInUp">
      <MemberRights></MemberRights>
    </div>
    <div class="cont cont4 wow bounceInUp">
      <Contactus></Contactus>
    </div>
  </div>
</template>

<script>
import Intoduction from "@/components/Company/AssociationIntro/Intoduction";
import Presidentunit from "@/components/Company/AssociationIntro/Presidentunit";
import ServiceArea from "@/components/Company/AssociationIntro/ServiceArea";
import MemberRights from "@/components/Company/AssociationIntro/MemberRights";
import Contactus from "@/components/index/Contactus.vue";
export default {
  name: "AssociationIntro",
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  components: {
    Intoduction,
    Presidentunit,
    ServiceArea,
    MemberRights,
    Contactus,
  },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.AssociationIntro {
  position: relative;
  z-index: 9;
}
.cont1 {
  position: relative;
  &::before {
    content: "";
    display: block;
    width: 33px;
    height: 15px;
    background: url("../../assets/img/common/icon_sanjiao.png") top center
      no-repeat;
    background-size: cover;
    position: absolute;
    top: -13px;
    left: 186px;
    z-index: 66;
  }
}
.cont {
  width: $themeMinWidth;
  box-sizing: border-box;
  margin: 0 auto;
}
</style>
